<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 13:47:48
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 13:47:48
  * @Description: 选择器
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>
    <!-- <van-field
      readonly
      clickable
      :label="label"
      :name="name"
      :value="value"
      :right-icon="rightIcon"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :formatter="formatter"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup> -->
    <van-field
      readonly
      clickable
      :name="name"
      :label="label"
      :value="value"
      placeholder="点击选择日期"
      @click="showCalendar = true"
    />
    <van-calendar v-model="showCalendar" @confirm="onConfirm" />

  </div>
</template>

<script>

export default {
  name: 'PickerTimeForm',
  components: {},
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    defaultValue: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      value: this.defaultValue,
      currentDate: new Date(),
      showPicker: false,
      showCalendar: false
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    onConfirm(date) {
      // this.value = `${date.getMonth() + 1}/${date.getDate()}`
      this.showCalendar = false
      this.value = this.$moment(date).format('YYYY-MM-DD')
      this.$emit('onConfirmMouth', this.value)
      this.$store.dispatch('meetingtime/meetingCount', this.value)
      this.$emit('PickerMeetingtime', this.value)
      this.$emit('PickerMeetingtimeEnd', this.value)
    }
    // formatter(type, val) {
    //   if (type === 'year') {
    //     return `${val}年`
    //   } else if (type === 'month') {
    //     return `${val}月`
    //   } else if (type === 'day') {
    //     return `${val}日`
    //   }
    //   return val
    // }
    // 选择月  赋值
    // onConfirm(time) {
    //   this.value = this.$moment(time).format('YYYY-MM-DD')
    //   this.showPicker = false
    //   this.$emit('onConfirmMouth', this.value)
    // }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
